<template>
  <div>
    <!-- 图文介绍 -->
    <div class="item" v-for="(item,index) in dataList.filter(m=>m.type=='Content')" :key="index">
      <div class="container">
        <div class="row">
          <!-- -----------------文字----------------- -->
          <div
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="50"
            data-aos-duration="800"
            :class="{'col-12 col-sm text':true,'order-sm-1':index%2!=0}"
            v-if="item.title"
          >
            <!-- 标题 -->
            <div>
              <h2>{{item.title}}</h2>
              <div class="title-bar" :style="{background:`rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.3)`}"></div>
            </div>
            <!-- 详细描述 -->
            <p :style="{fontSize:'18px',color:'#7a8599'}">{{item.desc}}</p>
            <!-- 主按钮 -->
            <a v-if="item.mainButtonText" :href="item.mainButtonActiveValue">
              <el-button :type="item.mainButtonType||'success'" style="width: 120px;">{{ item.mainButtonText }}</el-button>
            </a>
            <!-- 副按钮 -->
            <a v-if="item.secondButtonText" :href="item.secondButtonActiveValue">
              <el-button :type="item.secondButtonType||'success'" style="width: 120px;">{{ item.secondButtonText }}</el-button>
            </a>
          </div>
          <!-- -----------------图片----------------- -->
          <div
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="50"
            data-aos-duration="800"
            :class="{'col-12 col-sm':true}"
            v-if="item.imageUrl"
          >
            <img :src="item.imageUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'aos/dist/aos.css'
import AOS from 'aos/dist/aos.js'

export default {
  props: {
    dataList: {
      type: Array,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      // mHref: ''
    }
  },
  watch: {},
  methods: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  mounted() {},
  created() {
    // this.utils.refreshSoftPrice(this.onloadArgs.getInvite())
    // this.mHref = this.gSetting.product.swiperList[0].buttons[0].href
    AOS.init({
      offset: 100,
      duration: 300,
      easing: 'ease-in-sine'
    })
  }
}
</script>
<style lang="scss" scoped>
/* 手机版 */
@media screen and (max-width: 576px) {
  .item {
    padding: 10px 0 !important;
    max-height: 500px !important;

    img {
      max-height: 280px !important;
      margin-top: 20px !important;
    }

    h2 {
      font-weight: normal !important;
      font-size: 24px !important;
    }
    .title-bar {
      width: 150px !important;
      height: 10px !important;
      margin-top: -20px !important;
      margin-bottom: 10px !important;
    }

    p {
      font-size: 14px !important;
    }
  }

  .item:nth-child(2n) {
    background: #fff !important;
  }
}

/* 电脑版 */
.item {
  text-align: center;
  // min-height: 500px;
  padding: 30px 0;
  max-height: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 400px;
  }

  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;

    h2 {
      font-size: 38px;
      font-weight: bold;
      line-height: 180%;
      color: #12141a;
    }
    .title-bar {
      width: 200px;
      height: 20px;
      margin-top: -30px;
      margin-left: auto;
      margin-right: auto;
    }

    p {
      line-height: 140%;
    }
  }
}

.item:nth-child(2n) {
  background: #f8f8f8;
}
</style>